export const USER_ROUTE_NAMES = {
  USER_LIST: 'user-list',
  USER_EDIT: 'user-edit',
}
